const DEFAULT_CENTER = { lat: 22.0964, lng: -159.5261 }
const DEFAULT_ZOOM = 9
const DESKTOP_MIN_ZOOM = 7
const MOBILE_MIN_ZOOM = 6
const HAWAII_BOUNDS = {
  north: 22.9,
  south: 18.6,
  west: -161.6,
  east: -154.1
}
const ISLAND_BOUNDS = {
  kauai: { north: 22.3, south: 21.8, west: -159.95, east: -159.2 },
  oahu: { north: 21.75, south: 21.2, west: -158.4, east: -157.6 },
  maui: { north: 20.95, south: 20.45, west: -156.8, east: -155.95 },
  'big-island': { north: 20.35, south: 18.9, west: -156.2, east: -154.7 }
}
const SITE_ISLAND_TO_PLANNER_ISLAND = {
  kauai: 'kauai',
  oahu: 'oahu',
  maui: 'maui',
  big_island: 'big-island'
}

function toIslandCenter(island) {
  if (island === 'oahu') return { lat: 21.468, lng: -157.965 }
  if (island === 'maui') return { lat: 20.7984, lng: -156.3319 }
  if (island === 'big-island') return { lat: 19.587, lng: -155.486 }
  if (island === 'kauai') return { lat: 22.052, lng: -159.5261 }
  return DEFAULT_CENTER
}

function getHawaiiBoundsCenter() {
  return {
    lat: (HAWAII_BOUNDS.north + HAWAII_BOUNDS.south) / 2,
    lng: (HAWAII_BOUNDS.east + HAWAII_BOUNDS.west) / 2
  }
}

function getIslandForLatLng(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
  return Object.entries(ISLAND_BOUNDS).find(([, bounds]) => (
    lat <= bounds.north &&
    lat >= bounds.south &&
    lng >= bounds.west &&
    lng <= bounds.east
  ))?.[0] || null
}

function getIslandZoom(island, isMobile) {
  const zooms = {
    kauai: { desktop: 11, mobile: 10 },
    oahu: { desktop: 10, mobile: 9 },
    maui: { desktop: 10, mobile: 9 },
    'big-island': { desktop: 9, mobile: 8 }
  }
  const entry = zooms[island] || { desktop: DEFAULT_ZOOM, mobile: DEFAULT_ZOOM }
  return isMobile ? entry.mobile : entry.desktop
}

function normalizePlannerIsland(value) {
  if (value === 'big_island') return 'big-island'
  if (value === 'big-island' || value === 'kauai' || value === 'oahu' || value === 'maui') return value
  return null
}

function isValidLatLng(lat, lng) {
  return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180
}

export function getInitialPlannerMapState({
  params = new URLSearchParams(),
  runtimeIsland,
  isApexHost = false,
  isMobile = false
} = {}) {
  const hostIsland = isApexHost
    ? null
    : SITE_ISLAND_TO_PLANNER_ISLAND[runtimeIsland] || null
  const explicitIslandParam = normalizePlannerIsland(params.get('island')) || null
  const initialLat = Number(params.get('lat'))
  const initialLng = Number(params.get('lng'))
  const zoomParam = params.get('z')
  const initialZoom = zoomParam === null ? null : Number(zoomParam)
  const hasValidCenter =
    isValidLatLng(initialLat, initialLng) &&
    !(Math.abs(initialLat) < 1e-6 && Math.abs(initialLng) < 1e-6)
  const inferredIsland = hasValidCenter ? getIslandForLatLng(initialLat, initialLng) : null
  const resolvedIsland = inferredIsland || explicitIslandParam || hostIsland || 'kauai'
  const shouldDefaultToOverview = !hasValidCenter && !explicitIslandParam && !hostIsland
  const center = shouldDefaultToOverview
    ? getHawaiiBoundsCenter()
    : hasValidCenter
      ? { lat: initialLat, lng: initialLng }
      : toIslandCenter(resolvedIsland)
  const minZoom = isMobile ? MOBILE_MIN_ZOOM : DESKTOP_MIN_ZOOM
  const defaultIslandZoom = getIslandZoom(resolvedIsland, isMobile)
  const zoom = Number.isFinite(initialZoom)
    ? Math.max(initialZoom, minZoom)
    : shouldDefaultToOverview
      ? minZoom
      : defaultIslandZoom

  return {
    center,
    explicitIslandParam,
    hasValidCenter,
    hostIsland,
    inferredIsland,
    isOverview: shouldDefaultToOverview,
    island: resolvedIsland,
    zoom
  }
}
